import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_cover_promotion_image_size.js";
import "./menu_cover_promotion_type.js";
//#region src/menu_cover_promotion_type_helper.ts
var menu_cover_promotion_type_helper_exports = /* @__PURE__ */ __exportAll({
	isFullWidth: () => isFullWidth,
	isHalfWidth: () => isHalfWidth,
	isValidMedium: () => isValidMedium,
	isValidSmall: () => isValidSmall,
	name: () => name,
	requiredMinimumCount: () => requiredMinimumCount,
	validPromotionImageSizeForPromotionType: () => validPromotionImageSizeForPromotionType
});
function name(promotionType) {
	switch (promotionType) {
		case "carousel-s": return "Carousel (Small)";
		case "carousel-m": return "Carousel (Medium)";
		case "carousel-r": return "Carousel (Regular)";
		case "grid-s": return "Grid (Small)";
		case "grid-m": return "Grid (Medium)";
		case "grid-r": return "Grid (Regular)";
		case "single-s": return "Single (Small)";
		case "single-m": return "Single (Medium)";
		case "single-r": return "Single (Regular)";
		case "gcn": return "GCN";
	}
}
function requiredMinimumCount(promotionType) {
	switch (promotionType) {
		case "carousel-s":
		case "carousel-m":
		case "carousel-r": return 3;
		case "grid-s":
		case "grid-m":
		case "grid-r": return 2;
		case "single-s":
		case "single-m":
		case "single-r": return 1;
		case "gcn": return 0;
	}
}
function isValidMedium(promotionType) {
	return promotionType === "carousel-m" || promotionType === "single-m" || promotionType === "grid-m";
}
function isValidSmall(promotionType) {
	return promotionType === "carousel-s" || promotionType === "single-s" || promotionType === "grid-s";
}
function isFullWidth(promotionType) {
	return promotionType === "carousel-s" || promotionType === "carousel-m" || promotionType === "single-s" || promotionType === "single-m";
}
function isHalfWidth(promotionType) {
	return promotionType === "grid-s" || promotionType === "grid-m";
}
function validPromotionImageSizeForPromotionType(promotionType) {
	switch (promotionType) {
		case "grid-s": return ["vitrine-sm-half-width"];
		case "grid-m": return ["vitrine-md-half-width"];
		case "grid-r": return ["vitrine-rg-half-width"];
		case "carousel-s":
		case "single-s": return ["vitrine-sm-full-width"];
		case "carousel-m":
		case "single-m": return ["vitrine-md-full-width"];
		case "carousel-r":
		case "single-r": return ["vitrine-rg-full-width"];
		case "gcn": return [];
	}
}
//#endregion
export { isFullWidth, isHalfWidth, isValidMedium, isValidSmall, menu_cover_promotion_type_helper_exports, name, requiredMinimumCount, validPromotionImageSizeForPromotionType };

//# sourceMappingURL=menu_cover_promotion_type_helper.js.map